export default "__VITE_ASSET__DO8bLU3d__"